<template>
  <div class="index">
    <vsmallheader></vsmallheader>
    <!-- 新闻 -->
    <div class="indexsst">
      <div class="newheaderTwo" :style=" `background-image: url(${columnList.logUrl})`"></div>

      <div class="newsimg-newText">
        <div class="news img-news" @mouseenter="autoplay = false" @mouseleave="autoplay = true">
          <nodata v-if="carousels.length<=0" style="padding-top: 100px;"></nodata>
          <el-carousel
            ref="newsCarousel"
            trigger="click"
            height="350px"
            width="520px"
            :autoplay="autoplay"
            v-if="carousels.length>0"
            indicator-position="none"
            style="z-index: 0;width: 545px;"
            @change="carouselHandleChange"
          >
            <el-carousel-item v-for="(item, index) in carousels" :key="index" :name="'' + index">
              <div class="carousel-inner">
                <img
                  :src="item.imgUrl"
                  :alt="item.title"
                  @click="carouselsHandleClick(item)"
                  :draggable="false"
                />
                <div class="carousel-title">
                  <span @click="carouselsHandleClick(item)">
                    {{
                    item.title
                    }}
                  </span>
                  <div class="carousel-indicator">
                    <div v-for="(item, index) in carousels" :key="index"></div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="carousel-indicator">
            <div
              v-for="(item, index) in carousels"
              :key="index"
              :class="{ active: carouselActive === index }"
              @click="setActiveItem(index)"
            ></div>
          </div>
        </div>

        <div class="text-news" v-for="(item, index) in tablistwoList" :key="index" v-if="index<1">
          <div class="textnewHed">
            <ul class="resourceIRLeftTab">
              <li class="resourceIRLeftTabli resourceIRLeactive">
                <div class="tabstext">{{ item.cateName }}</div>
              </li>
            </ul>
            <div class="textnewHedright" @click="pushnewslist(item)">
              <div>更多</div>
              <i>> ></i>
            </div>
          </div>
          <!-- 渐变线条 -->
          <div class="gitern"></div>
          <nodata v-if="item.artList.length<=0" style="padding-top: 100px;"></nodata>
          <ul class="tabs-main" v-else>
            <li v-for="(newsItem, newsIndex) in item.artList" :key="newsIndex">
              <div class="bordeRou"></div>

              <div
                @click="newsHandleClick(newsItem, newsIndex)"
                class="titleLbae"
                :title="newsItem.aritlceName"
                style="width:468px"
              >{{ newsItem.aritlceName }}</div>
              <!-- <div class="titleNmae">{{ newsItem.name }}</div> -->
              <div style="padding-left:3px">({{ newsItem.readCount }})</div>
              <div
                class="titleLbaetime"
                style="width:80px;padding-right:0;padding-left:5px"
              >{{ newsItem.publishTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="indexssty" style="position: relative;">
      <div class="newsimg-newText" style="flex-wrap: wrap;" v-if="tablistwoList.length>=1">
        <div class="text-newsl" v-for="(item, index) in tablistwoList" :key="index" v-if="index>=1">
          <div class="textnewHed">
            <ul class="resourceIRLeftTab">
              <li class="resourceIRLeftTabli resourceIRLeactive">
                <div class="tabstext">{{ item.cateName }}</div>
              </li>
            </ul>
            <div class="textnewHedright" @click="pushnewslist(item)">
              <div>更多</div>
              <i>> ></i>
            </div>
          </div>
          <!-- 渐变线条 -->
          <div class="gitern"></div>
          <nodata v-if="item.artList.length<=0" style="padding-top: 100px;"></nodata>
          <ul class="tabs-main" v-else>
            <li v-for="(newsItem, newsIndex) in item.artList" :key="newsIndex">
              <div class="bordeRou"></div>

              <div
                @click="newsHandleClick(newsItem, newsIndex)"
                class="titleLbae"
                style="width:435px"
                :title="newsItem.aritlceName"
              >{{ newsItem.aritlceName }}</div>
              <div style="padding-left:3px">({{ newsItem.readCount }})</div>
              <div
                class="titleLbaetime"
                style="width:80px;padding-right:0;padding-left:5px"
              >{{ newsItem.publishTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 课程和资源 -->
    <div class="training-school-inner">
      <div class="training-school-head">
        <ul class="resourceIRLeftTab">
          <li
            class="resourceIRLeftTabli"
            v-for="(item, index) in remediumListTab"
            :key="index"
            @click="remeDnewTab(index, item)"
            :class="{ resourceIRLeactive: index == nowIndexremeD }"
          >
            <div class="tabstext">{{ item.name }}</div>
          </li>
        </ul>

        <div class="gdbox">
          <span class="navLi" @click="gotoschool"><span>查看更多</span><i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
      <!-- 渐变线条 -->
      <div class="gitern"></div>

      <div class="trainingvideo">
        <div class="trainingvideright">
          <nodata v-if="schoolData.length<=0" style="margin:50px 550px;"></nodata>
          <div
            class="course-box"
            v-for="(item,index) in schoolData"
            :key="index"
            @click="newsVideo(item)"
          >
            <img class="course-box-img" :src="item.imgurl" />
            <div class="course-box-box">
              <span class="course-box-title" :title="item.name">{{item.name}}</span>
              <span class="course-box-text" :title="item.introduce">{{item.introduce}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 培训班 -->
    <div class="test-center-centerBox">
      <div class="test-center-center">
        <div class="test-center-centerleft">
          <div class="test-center-head">
            <div class="should">培训动态</div>
            <div class="gdbox">
              <span class="navLi" @click="gotoTrain"><span>查看更多</span><i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
          <!-- 渐变线条 -->
          <div class="gitern"></div>
          <div class="tableliborderlicent">
            <nodata v-if="traintList.length<=0" style="padding-top: 100px;"></nodata>
            <ul class="tabs-main">
              <li
                v-for="(newsItem, newsIndex) in traintList"
                :key="newsIndex"
                @click="trainClick(newsItem, newsIndex)"
              >
                <div class="bordeRou"></div>
                <div class="titleLbae onele">{{ newsItem.title }}</div>
                <div class="titleNmae">{{newsItem.deptname}}</div>
                <div class="titleLbaetime onele">{{ newsItem.createtime }}</div>
              </li>
            </ul>
          </div>
        </div>

        <div class="test-center-centerright">
          <div class="test-center-centerrighthed">
            <!-- <img src="@/assets/newIndex/u30925.png" /> -->
            <div class="should">问卷测评</div>
            <div class="gdbox">
              <span class="navLi" @click="gotoQuestion"><span>查看更多</span><i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
          <!-- 渐变线条 -->
          <div class="gitern"></div>
          <nodata v-if="pollList.length<=0" style="padding-top: 100px;"></nodata>
          <ul class="tabs-main">
            <li v-for="(newsItem, newsIndex) in pollList" :key="newsIndex">
              <div class="bordeRou"></div>
              <div
                @click="pollClick(newsItem, newsIndex)"
                class="titleLbae onele"
              >{{ newsItem.name }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as homes from '@/api/clientshome/index.js';
import * as resourceInfo from '@/api/resources/index.js';
// import nodata from '@/components/nodata'
import vsmallheader from '@/views/smallHeader/index';
import LineCom from '@/components/linecom';

export default {
  components: { vsmallheader, LineCom },
  data() {
    return {
      enterDialogVisible: false, //进入考试弹框
      titleExam: '',
      value0: '',
      value1: '',
      value2: '',
      value3: '',
      indexactive: 0,
      headerImg: require('@/assets/newIndex/hederImg.png'),
      criminalImg: require('@/assets/newIndex/u31088.jpg'),
      carousels: [],
      resourcesList: [],
      autoplay: true,
      carouselActive: 0,
      textnewsdata: [],
      schoolData: [],
      nowIndex: 0,
      drillmasters: [],
      tablistwoList: [],
      remediumListTab: [{ id: 2, name: '课程' }],
      nowIndexspecial: 0, //课程的id
      nowIndexResource: 0, //资源的id
      nowIndexremeD: 0, //调训的ID
      nowIndexTg: 0, //新闻的ID
      nowIndexTgCareId: 197,
      newslistST: [], //最新消息的列表
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      remediumList: [],
      specialId: this.$route.query.id,
      type: this.$route.query.type,
      pollList: [],
      traintList: [],
      columnList: {},
    };
  },
  created() {
    this.templates = this.$store.getters.templates;
    this.getColumnListById();
    this.getArticleCate();
    this.getPicAritlce();

    this.getDocumentList();
    this.getTraintList();
    this.getPollList();
  },

  methods: {
    getArticleCate() {
      homes
        .GetArticleCateNew({ specialId: this.specialId, top: 10 })
        .then((res) => {
          console.log(res);
          this.tablistwoList = res.result;
        });
    },
    getColumnListById() {
      homes.getColumnListById({ id: this.specialId }).then((res) => {
        this.columnList = res.result;
      });
    },
    pollClick(item) {
      this.$router.push({
        path: '/diaoy/questionget',
        query: {
          id: item.objeid,
        },
      });
    },
    gotoQuestion() {
      this.$router.push('/diaoy');
    },
    trainClick(item) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: item.objeid,
        },
      });
    },
    gotoTrain() {
      this.$router.push('/train');
    },
    //培训班列表
    getTraintList() {
      homes.getTraintList({ specialId: this.specialId }).then((res) => {
        this.traintList = res.result;
      });
    },
    //问卷列表
    getPollList() {
      homes.getPollList({ specialId: this.specialId }).then((res) => {
        this.pollList = res.result;
      });
    },

    //资源列表
    getDocumentList() {
      homes.getDocumentList({ specialId: this.specialId }).then((res) => {
        this.schoolData = res.result;
      });
    },
    //微警校专题和课程列表
    getCourseList() {
      homes.getCourseList({ specialId: this.specialId }).then((res) => {
        this.schoolData = res.result;
      });
    },

    // 微警校数据
    gotoschool() {
      this.$router.push('/mooc');
    },
    newsVideo(item) {
      resourceInfo.DocumentRead(item.objid).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: item.objid,
        },
      });
      //跳转路由时记录当前为哪一页，返回时调取数据保留在当前页
      localStorage.setItem('currpage', this.listQuerys.Page);
    },
    // 图片新闻数据
    getPicAritlce() {
      let para = {
        top: 6,
        specialid: this.specialId,
      };
      homes.getPicAritlce(para).then((res) => {
        this.carousels = res.result;
      });
    },
    remeDnewTab(index, item) {
      this.nowIndexremeD = index;
      this.getDocumentList();
    },
    // 新闻切换
    newTab(index, item) {
      this.nowIndexTg = index;
      this.nowIndexTgCareId = item.cateid;
      this.getArticleList();
    },
    ResourceTab(index, item) {
      this.nowIndexResource = index;
    },

    enterTab(index) {
      this.nowIndex = index;
    },

    TabIndexType(index, path) {
      this.indexactive = index;
      this.$router.push(path);
    },

    // tab切换
    toggleTabs(index) {
      this.nowIndex = index;
    },
    // 点击更多进入新闻列表页面
    pushnewslist(item) {
      this.$router.push({
        path: '/home/newsList',
        query: {
          CateId: item.cateId,
        },
      });
    },
    // 点击跳转新闻详细页面
    newsHandleClick(item, index) {
      console.log(item);
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          CateId: this.nowIndexTgCareId,
          id: item.aritlceId,
        },
      });
    },
    carouselHandleChange(index) {
      this.carouselActive = index;
    },
    setActiveItem(index) {
      this.$refs.newsCarousel.setActiveItem(index);
    },
    carouselsHandleClick(carousel) {
      console.log(carousel);
      let a = {
        id: carousel.id,
      };
      homes.CmsArticleReadCount(a).then((res) => {});
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          id: carousel.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  background-color: #fff;
  padding-bottom: 40px;
}

.indexsst {
  position: relative;
  .newheaderTwo {
    height: 200px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .newheaderTwo-img {
      width: 130px;
      height: 130px;
      border-radius: 50%;
    }
    .newheaderTwo-title {
      color: white;
      font-size: 48px;
      font-weight: 700;
      margin-top: 20px;
    }
  }
}
.resourceIRLeftTab {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color: #666666;
  line-height: 24px;
  height: 25px;
  .resourceIRLeftTabli {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    letter-spacing: 1px;
    &:hover {
      color: #1492ff;
      cursor: pointer;
    }
  }
  .navLi:hover {
    border-bottom: solid 1px #1492ff;
  }
  .tabstext {
    margin-left: 10px;
    margin-right: 10px;
  }
}
.resourceIRLeactive {
  color: #1492ff;
  cursor: pointer;
  font-weight: bold;
}

//
.newsimg-newText {
  display: flex;
  background-color: #fff;
  padding: 20px;
  width: 1160px;
  margin: 0 auto;
  margin-top: 35px;
  box-shadow: 0 0 10px rgb(242 242 242 / 99%);
  border-radius: 5px;
  border-width: 1px;
  justify-content: space-between;
}

// 新闻动态
.img-news {
  position: relative;
  width: 545px;
  height: 350px;
  .carousel-inner {
    position: relative;
    height: 350px;
    width: 545px;
    font-size: 0;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    > .carousel-title {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      background: #00000066;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        display: block;
        width: 350px;
        margin: 0 20px;
        font-size: 16px;
        color: #fff;
        line-height: 1;
        transition: 0.3s;
        cursor: pointer;

        @include style-ellipsis;

        &:hover {
          @include themeify {
            color: themed('color-text-placeholder');
          }
        }
      }

      > .carousel-indicator {
        height: 40px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        visibility: hidden;
        > div {
          padding: 4px;
          border-radius: 50%;
          transition: 0.3s;
          cursor: pointer;

          @include themeify {
            background: themed('color-white');
          }

          &.active {
            @include themeify {
              background: themed('color-primary');
            }
          }

          & + div {
            margin-left: 6px;
          }
        }
      }
    }
  }

  > .carousel-indicator {
    position: absolute;
    right: 0;
    bottom: 0px;
    height: 40px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    z-index: 1;

    > div {
      padding: 6px;
      background: #fff;
      border-radius: 50%;
      transition: 0.3s;
      cursor: pointer;

      &.active {
        @include themeify {
          background: themed('color-primary');
        }
      }

      & + div {
        margin-left: 6px;
      }
    }
  }
}

.text-newsl {
  width: 570px;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .textnewHed {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    color: #1492ff;

    .textnewHedleft {
      display: flex;
      flex: 1;
      font-size: 18px;
      font-weight: bold;

      img {
        height: 25px;
        width: 25px;
        margin-right: 10px;
      }
    }
    .textnewHedright {
      display: flex;
      align-items: center;
      font-size: 16px;
      text-align: right;
      cursor: pointer;
    }
    .textnewHedright:hover {
      border-bottom: solid 1px #1492ff;
    }
  }
  .tabs-main {
    padding-top: 10px;
    height: 300px;
    overflow-y: auto;
    li {
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      .bordeRou {
        height: 5px;
        width: 5px;
        border-radius: 50%;
        background: #1492ff;
      }
      .titleLbae {
        width: 500px;
        margin-left: 10px;
        font-size: 16px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .titleNmae {
        width: 200px;
        padding: 0 5px;
        font-size: 14px;
        color: #666;
      }
      .titleLbaetime {
        width: 83px;
        padding: 0 10px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}
// 最近更新
.text-news {
  width: 600px;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .textnewHed {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    color: #1492ff;

    .textnewHedleft {
      display: flex;
      flex: 1;
      font-size: 18px;
      font-weight: bold;

      img {
        height: 25px;
        width: 25px;
        margin-right: 10px;
      }
    }
    .textnewHedright {
      display: flex;
      align-items: center;
      font-size: 16px;
      text-align: right;
      cursor: pointer;
    }
    .textnewHedright:hover {
      border-bottom: solid 1px #1492ff;
    }
  }
  .tabs-main {
    padding-top: 10px;
    height: 300px;
    overflow-y: auto;
    li {
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      .bordeRou {
        height: 5px;
        width: 5px;
        border-radius: 50%;
        background: #1492ff;
      }
      .titleLbae {
        width: 640px;
        margin-left: 10px;
        font-size: 16px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .titleNmae {
        width: 200px;
        padding: 0 5px;
        font-size: 14px;
        color: #666;
      }
      .titleLbaetime {
        width: 155px;
        padding: 0 5px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}

.onele {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; //行数需设置
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.gitern {
  height: 1px;
  width: 100%;
  background: #d7d7d7;
}

// 微警校
.training-school-inner {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 35px;
  padding: 10px;
  box-shadow: 0 0 10px rgb(242 242 242 / 99%);
  box-sizing: border-box;
  .training-school-head {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    list-style-type: none;
    .gdbox {
      flex: 1;
      color: #1492ff;
      font-size: 16px;
      text-align: right;
    }
    img {
      width: 26px;
      height: 26px;
    }
    box-sizing: border-box;
    display: flex;

    @include themeify {
      border-color: themed('color-border-base');
    }
    .should {
      font-size: 18px;
      color: #1492ff;
      padding-left: 10px;
      font-weight: bold;
    }
  }
  .trainingvideo {
    padding-top: 20px;
    padding-bottom: 10px;
    display: flex;
    // width: 1200px;
    .trainingvideright {
      flex: 1;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .course-box {
        //   width: 300px;
        height: 100px;
        padding: 10px;
        display: flex;
        margin-right: 33px;
        &:hover {
          cursor: pointer;
        }
        .course-box-img {
          width: 160px;
          height: 100px;
        }
        .course-box-box {
          width: 170px;
          padding-left: 10px;
          .course-box-title {
            font-weight: 700;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            margin-bottom: 10px;
            &:hover {
              color: #1492ff;
            }
          }
          .course-box-text {
            font-size: 14px;
            color: #7f7f7f;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
.navLi:hover {
  border-bottom: solid 1px #1492ff;
  cursor: pointer;
}
// 考试咨询
.test-center-centerBox {
  margin: 0 auto;
  width: 1200px;
  margin-top: 35px;
  //   padding: 10px;
  box-sizing: border-box;
  .test-center-center {
    display: flex;
    // flex-wrap: wrap;

    .test-center-centerleft {
      font-size: 16px;
      font-weight: 500;
      width: 860px;
      padding-bottom: 20px;
      border-radius: 6px;
      min-height: 360px;
      box-shadow: 0 0 10px rgb(242 242 242 / 99%);
      padding: 10px;
      .test-center-head {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        .should {
          font-size: 18px;
          font-weight: bold;
          color: #1492ff;
          padding-left: 10px;
        }
        img {
          height: 25px;
          width: 25px;
        }
        .gdbox {
          flex: 1;
          text-align: right;
          font-size: 16px;
          color: #1492ff;
        }
      }

      .tableliborderlicent {
        border-radius: 5px;
        margin-top: 20px;
        height: 330px;
        overflow-y: auto;
        .tabs-main {
          padding-top: 10px;
          padding-bottom: 20px;
          li {
            display: flex;
            align-items: center;
            padding-bottom: 9px;
            .bordeRou {
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background: #1492ff;
            }
            .titleLbae {
              width: 460px;
              margin-left: 10px;
              font-size: 16px;
              color: #000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &:hover {
                color: #1492ff;
                text-decoration: underline;
                cursor: pointer;
              }
            }
            .titleNmae {
              width: 200px;
              padding: 0 5px;
              font-size: 14px;
              color: #666;
            }
            .titleDtpeNmae {
              width: 200px;
              padding: 0 5px;
              font-size: 14px;
              color: #666;
            }
            .titleLbaetime {
              width: 150px;
              padding: 0 5px;
              font-size: 14px;
              color: #666;
            }
          }
        }
        .tablelitwo {
          display: flex;
          text-align: center;
          margin-top: 10px;
          font-size: 14px;
          .dillclassName {
            width: 280px;
            font-size: 16px;
            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .stuat {
            height: 20px;
            width: 75px;
            border-radius: 5px;
            border: 1px solid #000;
            color: #000;
          }
          .apply {
            width: 220px;
            color: #666;
          }
          .policeclassification {
            width: 60px;
            color: #666;
          }
          .openingceremony {
            width: 220px;
            color: #666;
          }
        }
      }
    }
    .test-center-centerright {
      width: 320px;
      margin-left: 20px;
      border-radius: 6px;
      padding-bottom: 20px;
      .tabs-main {
        padding-top: 30px;
        padding-bottom: 20px;
        height: 300px;
        overflow-y: auto;
        li {
          display: flex;
          align-items: center;
          padding-bottom: 9px;
          .bordeRou {
            height: 5px;
            width: 5px;
            border-radius: 50%;
            background: #1492ff;
          }
          .titleLbae {
            width: 300px;
            margin-left: 10px;
            font-size: 16px;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .titleNmae {
            width: 200px;
            padding: 0 5px;
            font-size: 14px;
            color: #666;
          }
          .titleDtpeNmae {
            width: 200px;
            padding: 0 5px;
            font-size: 14px;
            color: #666;
          }
          .titleLbaetime {
            width: 150px;
            padding: 0 5px;
            font-size: 14px;
            color: #666;
          }
        }
      }
      .test-center-centerrighthed {
        display: flex;
        align-items: center;
        font-weight: 500;
        text-align: center;
        padding: 10px;
        img {
          width: 26px;
          height: 26px;
        }
        .should {
          font-size: 18px;
          font-weight: bold;
          color: #1492ff;
          padding-left: 10px;
        }
        .gdbox {
          flex: 1;
          text-align: right;
          font-size: 16px;
          color: #1492ff;
        }
      }
      .statisticsul {
        height: 310px;
        padding: 0 20px;
        margin-top: 20px;
        border-radius: 5px;
        font-size: 16px;
        .statisticsli {
          display: flex;
          align-items: center;
          margin-top: 10px;
          color: #000;
          .columntext {
            display: block;
            font-size: 14px;
            padding: 0 5px;
            height: 20px;
            line-height: 20px;
            border-radius: 4px;
            border: 1px solid #000;
          }
          .columntNumber {
            padding-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>

